
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import AccountInput from '@byted/common-register-i18n-sdk/dist/sg/accountInput'
import { getLang } from '@/utils/unicodeUtil'
import { State } from 'vuex-class'
// @ts-ignored
@Component({
  name: 'PhoneInput'
})
export default class PhoneInput extends Vue {
  @State((state) => state?.account?.accountInfo?.country) country: string
  @Prop({ default: 'ad-lite-mobile-phone-input', type: String }) inputId: string
  @Prop({ default: '', type: String }) defaultAreaPhone: string
  @Prop({ default: 360, type: Number }) width: string
  @Prop({ default: 34, type: Number }) height: string

  phoneInputEl: any = null
  hasValidateError = false

  @Watch('defaultAreaPhone')
  onDefaultAreaPhoneChange(newVal: boolean) {
    if (newVal) {
      this.phoneInputEl && this.phoneInputEl?.setDefaultAreaPhone(newVal)
    }
  }

  checkHasValidateError() {
    this.$nextTick(() => {
      this.hasValidateError = Boolean(document.getElementById(this.inputId)?.querySelector('.error-message'))
    })
  }

  renderAccountInput() {
    this.phoneInputEl = new AccountInput({
      id: this.inputId,
      lang: getLang(),
      isMobile: true,
      width: this.width,
      defaultCountry: this.country,
      defaultAreaPhone: this.defaultAreaPhone,
      onChange: (areaPhone, phoneCountry) => {
        this.$emit('input', areaPhone, phoneCountry)
        this.checkHasValidateError()
      },
      onAreaChange: (area = '', country = '') => {
        this.$emit('areaChange', area, country)
        this.checkHasValidateError()
      },
    })
    this.phoneInputEl.render()
  }
  async validateTelephone() {
    // 先检测有无选择区号，后调用 libphonenumber-js 的 isValid/isPossible 方法
    const isValid = await this.phoneInputEl.isValid()
    this.checkHasValidateError()

    return isValid
  }
  setDefaultCountry(country) {
    this.phoneInputEl?.setDefaultCountry(country)
  }
  setDefaultAreaPhone(areaPhone) {
    this.phoneInputEl?.setDefaultAreaPhone(areaPhone)
  }
  setDefaultPhone(phone) {
    this.phoneInputEl?.setDefaultPhone(phone)
  }
  setPhoneHeight() {
    const height = `${this.height}px`
    const containerEl = document.querySelector('.phone-container')
    const el = document.querySelector(
      `#${this.inputId} .input-container-prefix`,
    )

    containerEl.style.height = height
    el.style.height = height
  }

  mounted() {
    this.renderAccountInput()
    this.setPhoneHeight()
  }
}
